import { TFunc } from '@Translations/types';
import * as yup from 'yup';

const nameSchema = (t: TFunc) =>
	yup
		.string()
		.trim('The contact name cannot include leading and trailing spaces')
		.required(t('Name is required'))
		.min(5, t('Name must be at least 5 characters'))
		.max(50, t('Name must be at most 50 characters'));

const apiKeySchema = (t: TFunc) =>
	yup
		.string()
		.required(t('API Key is required'))
		.min(5, t('API Key must be at least 5 characters'));

const portalUrlSchema = (t: TFunc) =>
	yup
		.string()
		.required(t('Portal URL is required'))
		.min(5, t('Portal URL must be at least 5 characters'))
		.test('is-url', t('Portal URL is not a valid URL'), value => {
			if (!value) return false;
			try {
				new URL(value);
				return true;
			} catch {
				return false;
			}
		});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const descriptionSchema = (t: TFunc) =>
	yup
		.string()
		.nullable(true)
		.optional()
		.max(400, t('Description must be at most 400 characters'));

const ITPipesSettingsShape = (t: TFunc) => ({
	name: nameSchema(t),
	apiKey: apiKeySchema(t),
	portalUrl: portalUrlSchema(t),
	description: descriptionSchema(t),
});

export const ITPipesSettingsSchema = (t: TFunc) =>
	yup.object().shape(ITPipesSettingsShape(t), [['sensors', 'sensorGroups']]);
